@defer (when rule()) {
  <app-page-title [label]="rule().title" [canGoBack]="true" (click)="goBack()" [links]="_links()" (onLinkClick)="linkClick($event)" />

  <div class="hero mt-1">
    <div class="chips">
      @if (assetsLeft()) {
        <app-chip tooltipPosition="top" [label]="assetsLeft().gateway.site.title" title="Site" [canClick]="false" />
        <app-chip tooltipPosition="top" [label]="assetsLeft().gateway.title" title="Gateway" [canClick]="false" />
      }
      <app-chip tooltipPosition="top" label="Created {{ rule().createdAt | date: 'dd/MM/yyyy' }}" title="Created {{ rule().createdAt | date: 'dd/MM/yyyy HH:MM' }}" [canClick]="false" />
    </div>
  </div>

  @if (rule().inAlert === 'Y') {
    <app-theme-page-section label="In Alarm, is {{ rule().alarm?.state }}." [isWarning]="true">
      <app-rulesv3-item-alarm-control [rule]="rule()" (onNoteAdded)="noteWasAdded($event)" (onStateChanged)="stateChanged($event)" />
    </app-theme-page-section>
  }

  <div class="fourd section-title">Conditions</div>
  @if (hasNoConditions) {
    <p class="red">This rule has no conditions and is disabled.</p>
  }

  <app-rulesv3-item-conditions [rule]="rule()"></app-rulesv3-item-conditions>

  @if (assetsLeft() && limitLines) {
    <div class="fourd section-title">Sensors</div>
    @if (assetsRight()) {
      <div>
        <app-setpoint-query view="compact" [showValue]="true" [assets]="[assetsLeft(), assetsRight()]"> </app-setpoint-query>
      </div>
    } @else {
      <div>
        <app-setpoint-query view="compact" [showValue]="true" [assets]="[assetsLeft()]" [limitLines]="limitLines" [fullscreen]="false"> </app-setpoint-query>
      </div>
    }
  }

  <div class="fourd section-title">Notifications</div>
  <app-rulesv3-item-contacts [rule]="rule()"></app-rulesv3-item-contacts>

  @if (rule().integration) {
    <app-rulesv3-item-elogbooks-details [rule]="rule()"></app-rulesv3-item-elogbooks-details>
  }

  <div class="fourd section-title">Alarms</div>
  <app-rulesv3-item-history [rule]="rule()" [assets]="[assetsLeft()]"></app-rulesv3-item-history>
} @placeholder (minimum 100ms) {
  <i class="mdi mdi-spin-x2 mdi-loading"></i>
}
